

import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import 'react-datepicker/dist/react-datepicker.css';
import styles from '../../assets/scss/Invoice/AddInvoice.module.scss';
import { FaTrashAlt, FaEdit } from 'react-icons/fa';
import Pagination from '../../Components/Common/Pagination';
import PopupWrapper from '../../Components/Common/PopupWrapper';
import AddItemPopup from './AddItemPopup';
import { useLocation, useNavigate } from 'react-router-dom';
import DeleteConfirmModal from '../../Components/Common/DeleteConfirmModal';
import {
    useGetInvoiceByIdQuery,
    useGetLogisticsQuery,
    useGetMyInvoicesQuery,
    useGetMyInvoicesselfQuery,
    useGetMyVendorsQuery,
    useGetUserByIdQuery
} from '../../slices/admin/admin';
import { BaseURL } from '../../lib/api';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getUserInfo } from '../../utils/user.util';
import ImagePriview from '../../Components/Common/ImagePriview';
import Select from "react-select";


const AddInvoice = () => {
    const [items, setItems] = useState([]);
    const [effectiveDate, setEffectiveDate] = useState(null);
    const [isAddItemOpen, setIsAddItemOpen] = useState(false);
    const [isModalOpen, setModalOpen] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [editIndex, setEditIndex] = useState(null);

    const [assignedTo, setAssignedTo] = useState('');
    const [paymentType, setPaymentType] = useState('');
    const [logisticsId, setLogisticsId] = useState('');
    const [logisticsAmount, setLogisticsAmount] = useState('');
    const [logisticsPaymentBy, setLogisticsPaymentBy] = useState('');
    const [saleCommission, setSaleCommission] = useState('');
    const [fieldErrors, setFieldErrors] = useState({});


    const [userData, setUserData] = useState(null);
    const navigate = useNavigate();

    // ✅ Helper: supports both full URLs and local paths
    const resolveImageUrl = (path) => {
        if (!path) return null;
        return path.startsWith('http') ? path : `${BaseURL}/${path}`;
    };


    const location = useLocation();
    const viewOnly = location.state?.viewOnly || false;
    const editMode = location.state?.editMode || false;
    const invoiceId = location.state?.invoiceId || null;

    const { data: invoiceData, refetch: invoiceDatarefetch } = useGetInvoiceByIdQuery(invoiceId, {
        skip: !invoiceId,
    });

    const { data: vendorsData } = useGetMyVendorsQuery();
    const stores = vendorsData?.stores || [];

    const { data: logisticsData } = useGetLogisticsQuery();
    const logisticsList = logisticsData?.logistics || [];

    const { refetch: invoiceListRefetch } = useGetMyInvoicesQuery({
        offset: 1,
        limit: 10,
    });

    const {
        data: myInvoices,
        refetch: invoiceListRefetchs,
        isFetching,
    } = useGetMyInvoicesselfQuery({
        offset: 1,
        limit: 10,
        status: '',
        invoiceStore: '',
        search: '',
        fromDate: '',
        toDate: '',
    });




    const [showImageModal, setShowImageModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    console.log(selectedImage, "selectedImage");




    const [showImage, setShowImage] = useState(false);

    const user = getUserInfo();
    const userId = user?._id;
    const { data: profileData } = useGetUserByIdQuery(userId, { skip: !userId });

    useEffect(() => {
        if (invoiceData?.invoices?.length && (viewOnly || editMode)) {
            const invoice = invoiceData.invoices[0];

            setAssignedTo(invoice.invoiceStore || '');
            setPaymentType(invoice.paymentType || '');
            setEffectiveDate(invoice.paymentDate || '');
            setLogisticsId(invoice.logisticsId || '');
            setLogisticsAmount(invoice.amount || '');
            setLogisticsPaymentBy(invoice.logisticsPaymentBy || '');
            setSaleCommission(invoice.saleCommission || '');




            const formattedItems = (invoice.items || []).map((item) => ({
                itemId: item._id,
                name: item.productName,
                quantity: Number(item.productQuantity),
                quality: item.productQuality,
                bag: item.productBag,
                productCount: Number(item.productCount),
                description: item.description || '',
                // imagePreview: `${BaseURL}/${item.profile}`,
                imagePreview: resolveImageUrl(item.profile),
                image: null,
            }));


            setItems(formattedItems);
        }
    }, [invoiceData, viewOnly, editMode]);

    useEffect(() => {
        if ((viewOnly || editMode) && invoiceData?.invoices?.length) {
            const invoice = invoiceData.invoices[0];
            setUserData({
                firstName: invoice?.createdBy?.firstName || '',
                lastName: invoice?.createdBy?.lastName || '',
                phone: invoice?.createdBy?.phone || '',
                address: invoice?.createdByStore
                    ? `${invoice.createdByStore.address1 || ''}, ${invoice.createdByStore.address2 || ''}, ${invoice.createdByStore.city || ''}, ${invoice.createdByStore.state || ''} - ${invoice.createdByStore.pincode || ''}`
                    : 'N/A',
            });
        } else if (!viewOnly && profileData?.result?.[0]) {
            const user = profileData.result[0];
            const store = user?.store;
            setUserData({
                firstName: user?.firstName || '',
                lastName: user?.lastName || '',
                phone: user?.phone || '',
                address: store
                    ? `${store.address1 || ''}, ${store.address2 || ''}, ${store.city || ''}, ${store.state || ''} - ${store.pincode || ''}`
                    : 'N/A',
            });
        }
    }, [viewOnly, editMode, invoiceData, profileData]);

    useEffect(() => {
        const storedItems = localStorage.getItem('invoiceItems');
        if (storedItems) {
            try {
                const parsed = JSON.parse(storedItems);
                // const sanitized = parsed.map(item => ({
                //     ...item,
                //     image: null
                // }));
                const sanitized = parsed.map(item => ({
                    ...item,
                    image: null,
                    imagePreview: resolveImageUrl(item.imagePreview || item.profile),
                }));

                setItems(sanitized);
            } catch (err) {
                console.error('Error parsing stored items:', err);
            }
        }
    }, []);





    const handleCancel = () => {
        localStorage.removeItem('invoiceItems');
        navigate(-1);
    };



    const handleSave = async () => {
        const errors = {};
        if (!saleCommission) {
            errors.saleCommission = 'Sale commission type is required';
        }

        // Transport fields are now optional


        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) return;

        if (items.length === 0) {
            toast.error('Please update at least one item.');
            return;
        }

        let token = localStorage.getItem('token');
        if (token?.startsWith('"') && token?.endsWith('"')) {
            token = token.slice(1, -1);
        }
        if (!token) {
            toast.error('Token is missing!');
            return;
        }

        try {
            if (editMode) {
                const updatePromises = items.map(async (item) => {
                    const itemId = item.itemId || item._id || item.id;
                    if (!itemId) return;

                    const formData = new FormData();
                    formData.append('productQuantity', item.quantity);
                    formData.append('productQuality', item.quality);
                    formData.append('productCount', item.productCount);
                    // formData.append('saleCommission', saleCommission); 

                    return axios.put(`${BaseURL}/invoiceItem/update/${itemId}`, formData, {
                        headers: { authorization: token },
                    });
                });

                await Promise.all(updatePromises);
                toast.success('Invoice items updated successfully!');
                invoiceDatarefetch();
                invoiceListRefetchs();
            } else {
                const formData = new FormData();
                formData.append('invoiceStore', assignedTo);
                // formData.append('paymentType', paymentType);
                // formData.append('paymentDate', effectiveDate);
                formData.append('logisticsId', logisticsId);
                formData.append('amount', logisticsAmount);
                formData.append('logisticsPaymentBy', logisticsPaymentBy);
                formData.append('saleCommission', saleCommission);

                const products = items.map((item, i) => {
                    const fieldName = `product${i + 1}profile`;
                    if (item.image && item.image instanceof File) {
                        formData.append(fieldName, item.image);
                    }
                    return {
                        productName: item.name,
                        productQuantity: Number(item.quantity),
                        productBag: item.bag,
                        productQuality: item.quality,
                        productCount: Number(item.productCount),
                        description: item.description || '',
                        fieldName,
                    };
                });

                formData.append('products', JSON.stringify(products));

                await axios.post(`${BaseURL}/invoice/create`, formData, {
                    headers: { authorization: token },
                });

                toast.success('Invoice created successfully!');
                invoiceListRefetch();
                invoiceListRefetchs();
            }
            localStorage.setItem('myInvoiceNeedsRefetch', 'true');
            navigate(-1);
            // navigate("/dashboard/Invoicetable?tab=myInvoice");
            localStorage.removeItem('invoiceItems');

        } catch (err) {
            console.error('Error saving invoice:', err);
            toast.error('Failed to save invoice');
        }
    };

    const confirmDelete = () => {
        const updated = items.filter((_, idx) => idx !== deleteId);
        setItems(updated);
        localStorage.setItem('invoiceItems', JSON.stringify(updated));
        setModalOpen(false);
    };

    const handleEdit = (item, index) => {
        setEditIndex((currentPage - 1) * limit + index);
        setIsAddItemOpen(true);
    };

    const totalPages = Math.ceil(items.length / limit);
    const paginatedItems = items.slice((currentPage - 1) * limit, currentPage * limit);


    return (
        <div className={styles.invoiceContainer}>
            <div className={styles.header}>
                {/* <h2 className={styles.tittle}>{viewOnly ? 'View Invoice' : 'Create Invoice'}</h2> */}
                <h2 className={styles.tittle}>{viewOnly ? 'View Invoice' : editMode ? 'Update Invoice' : 'Create Invoice'}</h2>
                <span className={styles.closeIcon} onClick={handleCancel}>×</span>
            </div>

            <div className={styles.AddInvoicehead}>
                <div className={styles.formSection}>
                    <div className={styles.assignRow}>

                        <div>
                            {!viewOnly && !editMode && (


                                <div className={styles.inputGroupss}>
                                    <label className={styles.inputLabel}>Invoice Placed To</label>
                                    <Select
                                        className={styles.customSelect}
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                border: "1px solid #6D6D6D",
                                                borderRadius: "6px",
                                                fontSize: "16px",
                                                minHeight: "50px",
                                                boxShadow: "none",
                                                color: "black",
                                                fontWeight: "600",
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                color: "#6D6D6D",
                                                fontSize: "16px",
                                                fontWeight: "600",
                                            }),
                                        }}
                                        value={
                                            stores.find((s) => s._id === assignedTo)
                                                ? {
                                                    value: assignedTo,
                                                    label: stores.find((s) => s._id === assignedTo)?.storeName,
                                                }
                                                : null
                                        }
                                        onChange={(selectedOption) =>
                                            setAssignedTo(selectedOption ? selectedOption.value : "")
                                        }
                                        options={stores.map((store) => ({
                                            value: store._id,
                                            label: store.storeName,
                                        }))}
                                        placeholder="Select Store"
                                        isSearchable
                                    />
                                </div>

                            )}
                            {!viewOnly && !editMode && (
                                <div className={styles.inputGroup}>
                                    <label className={styles.inputLabel}>Sale Commission</label>
                                    <select
                                        className={`${styles.inputs} ${fieldErrors.saleCommission ? styles.errorInput : ""
                                            }`}
                                        value={saleCommission}
                                        onChange={(e) => setSaleCommission(e.target.value)}
                                    >
                                        <option value="">Select option</option>
                                        <option value="percentage">Percentage (%)</option>
                                        <option value="price">Price ($)</option>
                                    </select>
                                    {fieldErrors.saleCommission && (
                                        <span className={styles.errorText}>
                                            {fieldErrors.saleCommission}
                                        </span>
                                    )}
                                </div>
                            )}
                        </div>





                        {userData ? (
                            <div className={styles.ownerCard}>
                                <p><strong>Item Owner :</strong> {userData.firstName} {userData.lastName}</p>

                                <p><strong>Phone No :</strong> {userData.phone}</p>
                            </div>
                        ) : (
                            <div className={styles.ownerCard}>
                                <p><strong>Item Owner :</strong> Loading...</p>

                                <p><strong>Phone No :</strong> Loading...</p>
                            </div>
                        )}



                    </div>

                    {(viewOnly || editMode) ? (
                        // ✅ SHOW IN VIEW & EDIT MODE
                        <div className={styles.ownerCards}>
                            <p>
                                <strong>Sale Commission :</strong>{" "}
                                {saleCommission === "percentage"
                                    ? "Percentage (%)"
                                    : saleCommission === "price"
                                        ? "Price ($)"
                                        : "N/A"}
                            </p>
                            <p>
                                <strong>Transport Name :</strong>{" "}
                                {invoiceData?.invoices?.[0]?.logisticStore?.storeName || "N/A"}
                            </p>
                            <p>
                                <strong>Transport Amount Accepted :</strong>{" "}
                                {logisticsAmount || "N/A"}
                            </p>
                            <p>
                                <strong>Transport Amount Paid ID :</strong>{" "}
                                {logisticsPaymentBy
                                    ? logisticsPaymentBy.charAt(0).toUpperCase() +
                                    logisticsPaymentBy.slice(1)
                                    : "N/A"}
                            </p>
                        </div>
                    ) : (
                        // ✅ SHOW ONLY IN CREATE MODE
                        <>
                            {/* <div className={styles.box}>
                                <h4>Commission Details</h4>
                                <div className={styles.grid}>
                                    <div className={styles.inputGroup}>
                                        <label className={styles.inputLabel}>Sale Commission</label>
                                        <select
                                            className={`${styles.inputs} ${fieldErrors.saleCommission ? styles.errorInput : ""
                                                }`}
                                            value={saleCommission}
                                            onChange={(e) => setSaleCommission(e.target.value)}
                                        >
                                            <option value="">Select option</option>
                                            <option value="percentage">Percentage (%)</option>
                                            <option value="price">Price ($)</option>
                                        </select>
                                        {fieldErrors.saleCommission && (
                                            <span className={styles.errorText}>
                                                {fieldErrors.saleCommission}
                                            </span>
                                        )}
                                    </div>
                                    <div className={styles.inputGroup}></div>
                                    <div className={styles.inputGroup}></div>
                                </div>
                            </div> */}

                            {/* <div className={styles.box}>
                                <h4>Transport Details</h4>
                                <div className={styles.grid}>
                                    <div className={styles.inputGroup}>
                                        <label className={styles.inputLabel}>Transport Name</label>
                                        <select
                                            className={styles.inputs}
                                            value={logisticsId}
                                            onChange={(e) => setLogisticsId(e.target.value)}
                                        >
                                            <option value="">Select Transport</option>
                                            {logisticsList.map((log) => (
                                                <option key={log._id} value={log._id}>
                                                    {log.store?.storeName || log.storeName || "Unnamed Logistics"}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className={styles.inputGroup}>
                                        <label className={styles.inputLabel}>Transport Amount Accepted</label>
                                        <input
                                            type="number"
                                            placeholder="TransportAmount"
                                            className={styles.input}
                                            value={logisticsAmount}
                                            onChange={(e) => setLogisticsAmount(e.target.value)}
                                        />
                                    </div>

                                    <div className={styles.inputGroup}>
                                        <label className={styles.inputLabel}>Transport Amount Paid ID</label>
                                        <select
                                            className={styles.inputs}
                                            value={logisticsPaymentBy}
                                            onChange={(e) => setLogisticsPaymentBy(e.target.value)}
                                        >
                                            <option value="">Select Type</option>
                                            <option value="farmer">Farmer</option>
                                            <option value="store">Store</option>
                                        </select>
                                    </div>
                                </div>
                            </div> */}
                        </>
                    )}





                </div>

                <div className={styles.tableHeader}>
                    {!viewOnly && !editMode && (
                        <button className={styles.addBtn} onClick={() => setIsAddItemOpen(true)}>+ Add Item</button>
                    )}

                </div>

                <div className={styles.tableWrapper}>
                    <table>
                        <thead>
                            <tr>
                                <th>Item Seq</th>
                                <th>Item Name</th>
                                <th>Item Descriptions</th>
                                <th>Item Quantity</th>
                                <th>Item Count</th>
                                <th>Item Quality</th>
                                <th>Item Scales</th>
                                <th>Item Images</th>
                                {!viewOnly && !editMode && <th>Actions</th>}

                            </tr>
                        </thead>

                        <tbody>
                            {paginatedItems.length > 0 ? paginatedItems.map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>


                                    <td>{item.name}</td>


                                    <td>{item.description}</td>


                                    {/* <td>
                                        {editMode ? (
                                            <input
                                                type="number"
                                                className={styles.tableInput}
                                                value={item.quantity}
                                                onChange={(e) => {
                                                    const updated = [...items];
                                                    updated[(currentPage - 1) * limit + index].quantity = e.target.value;
                                                    setItems(updated);
                                                }}
                                            />
                                        ) : (
                                            item.quantity || '-'
                                        )}
                                    </td>

                                    <td>
                                        {editMode ? (
                                            <input
                                                type="number"
                                                className={styles.tableInput}
                                                value={item.productCount}
                                                onChange={(e) => {
                                                    const updated = [...items];
                                                    updated[(currentPage - 1) * limit + index].productCount = Number(e.target.value);
                                                    setItems(updated);
                                                }}
                                            />
                                        ) : (
                                            item.productCount || '-'
                                        )}
                                    </td> */}

                                    <td>
                                        {editMode ? (
                                            <input
                                                type="number"
                                                className={styles.tableInput}
                                                value={item.quantity}
                                                onChange={(e) => {
                                                    const updated = [...items];
                                                    updated[(currentPage - 1) * limit + index].quantity = Number(e.target.value);
                                                    setItems(updated);
                                                }}
                                                disabled={Number(item.productCount) > 0}
                                            />
                                        ) : (
                                            item.quantity || '-'
                                        )}
                                    </td>

                                    {/* <td>
                                        {editMode ? (
                                            <input
                                                type="number"
                                                className={styles.tableInput}
                                                value={item.productCount || ''}
                                                onChange={(e) => {
                                                    const updated = [...items];
                                                    updated[(currentPage - 1) * limit + index].productCount = Number(e.target.value);
                                                    setItems(updated);
                                                }}
                                                disabled={Number(item.quantity) > 0}
                                            />
                                        ) : (
                                            item.productCount || '-'
                                        )}
                                    </td> */}

                                    {/* <td>
                                        {editMode ? (
                                            <input
                                                type="number"
                                                className={styles.tableInput}
                                                value={item.productCount === 0 ? '0' : item.productCount || ''}
                                                onChange={(e) => {
                                                    const updated = [...items];
                                                    updated[(currentPage - 1) * limit + index].productCount = Number(e.target.value);
                                                    setItems(updated);
                                                }}
                                                disabled={Number(item.quantity) > 0}
                                            />
                                        ) : (
                                            item.productCount === 0 ? '0' : item.productCount || '-'
                                        )}
                                    </td> */}

                                    <td>
                                        {editMode ? (
                                            <input
                                                type="number"
                                                className={styles.tableInput}
                                                value={item.productCount ?? ''}
                                                onChange={(e) => {
                                                    const updated = [...items];
                                                    updated[(currentPage - 1) * limit + index].productCount = Number(e.target.value);
                                                    setItems(updated);
                                                }}
                                                disabled={Number(item.quantity) > 0}
                                            />
                                        ) : (
                                            item.productCount === 0 || item.productCount ? item.productCount : '-'
                                        )}
                                    </td>





                                    <td>
                                        {editMode ? (
                                            <select
                                                className={styles.tableInput}
                                                value={item.quality}
                                                onChange={(e) => {
                                                    const updated = [...items];
                                                    updated[(currentPage - 1) * limit + index].quality = e.target.value;
                                                    setItems(updated);
                                                }}
                                            >
                                                <option value="">Select Quality</option>
                                                <option value="High">High</option>
                                                <option value="Medium">Medium</option>
                                                <option value="Low">Low</option>
                                            </select>
                                        ) : (
                                            item.quality
                                        )}
                                    </td>


                                    <td>{item.bag}</td>

                                    {/* <td>
                                        {item.imagePreview && (
                                            <img src={item.imagePreview} width="40" alt="item" />
                                        )}
                                    </td> */}

                                    <>
                                        <td>
                                            {item.imagePreview && (
                                                <img
                                                    src={item.imagePreview}
                                                    width="40"
                                                    height="40"
                                                    alt="item"
                                                    style={{ cursor: 'pointer', objectFit: 'cover' }}
                                                    onClick={() => setSelectedImage(item.imagePreview)}
                                                />
                                            )}
                                        </td>

                                        {selectedImage && (
                                            <ImagePriview
                                                isOpen={true}
                                                imageUrl={selectedImage}
                                                onClose={() => setSelectedImage(null)}
                                            />
                                        )}
                                    </>



                                    {!viewOnly && !editMode && (
                                        <td>
                                            <div className={styles.actionsss}>
                                                <FaEdit className={styles.icon} onClick={() => handleEdit(item, index)} />
                                                <FaTrashAlt className={styles.icon} onClick={() => {
                                                    setDeleteId((currentPage - 1) * limit + index);
                                                    setModalOpen(true);
                                                }} />
                                            </div>
                                        </td>
                                    )}

                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan="8" className={styles.noData}>No data found</td>
                                </tr>
                            )}
                        </tbody>

                    </table>

                    <div className={styles.paginationWrapper}>
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={(page) => setCurrentPage(page)}
                        />
                        <select
                            className={styles.inputsbtn}
                            value={limit}
                            onChange={(e) => {
                                setLimit(Number(e.target.value));
                                setCurrentPage(1);
                            }}
                        >
                            <option value={10}>10 rows</option>
                            <option value={25}>25 rows</option>
                            <option value={50}>50 rows</option>
                        </select>
                    </div>
                </div>



             

                {/* {!viewOnly && !editMode && (
                    <div className={styles.box}>
                       
                        <div className={styles.grid}>
                            <div className={styles.inputGroup}>
                                <label className={styles.inputLabel}>Transport Name</label>
                                <select
                                    className={styles.inputs}
                                    value={logisticsId}
                                    onChange={(e) => setLogisticsId(e.target.value)}
                                >
                                    <option value="">Select Transport</option>
                                    {logisticsList.map((log) => (
                                        <option key={log._id} value={log._id}>
                                            {log.store?.storeName || log.storeName || "Unnamed Logistics"}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className={styles.inputGroup}>
                                <label className={styles.inputLabel}>Transport Amount Accepted</label>
                                <input
                                    type="number"
                                    placeholder="TransportAmount"
                                    className={styles.input}
                                    value={logisticsAmount}
                                    onChange={(e) => setLogisticsAmount(e.target.value)}
                                />
                            </div>

                            <div className={styles.inputGroup}>
                                <label className={styles.inputLabel}>Transport Amount Paid ID</label>
                                <select
                                    className={styles.inputs}
                                    value={logisticsPaymentBy}
                                    onChange={(e) => setLogisticsPaymentBy(e.target.value)}
                                >
                                    <option value="">Select Type</option>
                                    <option value="farmer">Farmer</option>
                                    <option value="store">Store</option>
                                </select>
                            </div>

                        </div>

                    </div>
                )} */}
                <div className={styles.summaryCard}>

                    {!viewOnly && !editMode && (
                        <div className={styles.grid}>
                            <div className={styles.inputGroup}>
                                <label className={styles.inputLabel}>Transport Name</label>
                                <select
                                    className={styles.inputs}
                                    value={logisticsId}
                                    onChange={(e) => setLogisticsId(e.target.value)}
                                >
                                    <option value="">Select Transport</option>
                                    {logisticsList.map((log) => (
                                        <option key={log._id} value={log._id}>
                                            {log.store?.storeName || log.storeName || "Unnamed Logistics"}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className={styles.inputGroup}>
                                <label className={styles.inputLabel}>Transport Amount Accepted</label>
                                <input
                                    type="number"
                                    placeholder="TransportAmount"
                                    className={styles.input}
                                    value={logisticsAmount}
                                    onChange={(e) => setLogisticsAmount(e.target.value)}
                                />
                            </div>

                            <div className={styles.inputGroup}>
                                <label className={styles.inputLabel}>Transport Amount Paid ID</label>
                                <select
                                    className={styles.inputs}
                                    value={logisticsPaymentBy}
                                    onChange={(e) => setLogisticsPaymentBy(e.target.value)}
                                >
                                    <option value="">Select Type</option>
                                    <option value="farmer">Farmer</option>
                                    <option value="store">Store</option>
                                </select>
                            </div>

                        </div>
                    )}

                    <div className={styles.totalBox}>
                        <h4 className={styles.totalhead}>Total Item Count</h4>
                        <div className={styles.row}>
                            <p><strong>Total Quantity:</strong> {items.reduce((acc, item) => acc + Number(item.quantity || 0), 0)}</p>
                            <p><strong>Total Item Scales:</strong> {items.length.toString().padStart(2, '0')}</p>
                            <p><strong>Total Item Count : </strong>{items.length}</p>
                            <p><strong>Total  : </strong>{items.length}</p>

                        </div>
                    </div>
                    {/* <div className={styles.countBox}>
                        <div className={styles.countflex}>
                            <p><strong>Total Item Count</strong></p>
                            <h2>{items.length}</h2>
                        </div>
                        <hr />
                        <div className={styles.countflex}>
                            <p>Total</p>
                            <h2>{items.length}</h2>
                        </div>
                    </div> */}
                </div>

   {!viewOnly && (
                    <div className={styles.footerButtons}>
                        <button className={styles.cancel} onClick={handleCancel}>Cancel</button>
                        <button className={styles.saves} onClick={handleSave}>
                            {editMode ? 'Update the Invoice' : 'Submit the Invoice'}
                        </button>
                    </div>
                )}
            </div>


            {isAddItemOpen && (
                <PopupWrapper onClose={() => {
                    setIsAddItemOpen(false);
                    setEditIndex(null);
                }}>
                    <AddItemPopup
                        onClose={() => {
                            setIsAddItemOpen(false);
                            setEditIndex(null);
                        }}
                        storeId={assignedTo}
                        itemToEdit={items[editIndex]}
                        onSave={(newItem) => {
                            if (editIndex !== null) {
                                const updated = [...items];
                                updated[editIndex] = newItem;
                                setItems(updated);
                            } else {
                                setItems(prev => [...prev, newItem]);
                            }
                            setIsAddItemOpen(false);
                            setEditIndex(null);
                        }}
                    />
                </PopupWrapper>
            )}

            <DeleteConfirmModal
                isOpen={isModalOpen}
                onClose={() => setModalOpen(false)}
                onConfirm={confirmDelete}
            />
        </div>
    );
};

export default AddInvoice;





